import axios from 'axios';
import { getKjederegAdminApiUrl } from 'services';

export interface NaceHovedkategoriEndring {
  id: string;
  orgNr: string;
  juridiskNavn: string | null;
  gammelNaceKode: string;
  gammelNaceKodeBeskrivelse: string | null;
  nyNaceKode: string;
  nyNaceKodeBeskrivelse: string | null;
  detectedAt: string; // ISO
}

export interface NaceKodeInfo {
  code: string;
  version: string;
  isCurrentVersion: boolean;
  shortName: string | null;
  notes: string | null;
}

export async function getNaceEndringer(): Promise<NaceHovedkategoriEndring[]> {
  const url = `${getKjederegAdminApiUrl()}/brregsync/dashboard/jobs/nace-endringer`;
  const response = await axios.get<NaceHovedkategoriEndring[]>(url);
  return response.data;
}

export async function getNaceKodeInfo(code: string): Promise<NaceKodeInfo | null> {
  try {
    const url = `${getKjederegAdminApiUrl()}/NaceKode/${encodeURIComponent(code)}`;
    const response = await axios.get<NaceKodeInfo>(url);
    return response.data;
  } catch {
    return null;
  }
}
